import { render, staticRenderFns } from "./PreviewConsultationModal.vue?vue&type=template&id=dcb4ed4c"
import script from "./PreviewConsultationModal.vue?vue&type=script&lang=js"
export * from "./PreviewConsultationModal.vue?vue&type=script&lang=js"
import style0 from "./PreviewConsultationModal.vue?vue&type=style&index=0&id=dcb4ed4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports